import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import DefaultContainer from '../../../components/DefaultContainer/DefaultContainer';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import { Member } from '../../../components/Member/Member';
import { getClub, getClubMember } from '../../../service/clubs';

import { useUserStore } from '../../../store/useUser';
import { main_color_50 } from '../../../styles/_variables';

import styles from './MemberList.module.scss';
import useHeader from '../../../hooks/useHeader';

const MemberList: React.FC = () => {
  const { id, name: clubName } = useParams();

  const clubId = Number(id)

  const userId = useUserStore(state => state.id)
  const userIsAdmin = useUserStore(state => state.userIsAdmin)(clubId)
  const userIsMediator = useUserStore(state => state.userIsMediator)(clubId)
  
  const { data:members, isFetching: isFetchingClubUser } = useQuery(
    ['members', 'club', clubId],
    () => getClubMember(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const { data: club, isFetching: isFetchingClub } = useQuery(
    ['club', clubId],
    () => getClub(clubId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  useHeader({ header: clubName, subheader: 'Membros' });

  const isFetching = isFetchingClubUser || isFetchingClub

  if (isFetching) return null;

  if (!userId) return <DefaultContainer>Você precisa fazer login</DefaultContainer>

  if (club && club.isPrivate){
    const isMember = (members || []).find(member => member.userId === userId); 
    if (!isMember) return <DefaultContainer>Este clube é privado</DefaultContainer>
  }
  
  if(!(userIsAdmin || userIsMediator)) return <DefaultContainer>Você não tem permissão pra vê essa pagina</DefaultContainer>

  return (
    <div>
      <HeaderPage header="Membros" bageColor={main_color_50} />
      <div className={styles.clubsContainer}>
        {members?.map(member => {
          if (!member?.outClub && !member?.isKickedOut && member?.wasAccepted){
            return <Member editable={false} member={member} key={member.id} />
          }
        })}
      </div>
      
    </div>
  )
}

export default MemberList;